import { AxiosInstance } from 'axios';
import { AdministratorAttendancesRepository } from '@/model/repository/manager/administratorAttendances/AdministratorAttendancesRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): AdministratorAttendancesRepository => ({
    index(payload) {
      return Repository.get(`${resource}`, { params: payload });
    },
  });
